import React from "react";
import "./legalServices.css";

// Import your assets here
import CaseEvaluationIcon from "./assets/caseEvaluationIcon.png";
import LawyerAIIcon from "./assets/lawyerAIIcon.png";
import UrgentHelpIcon from "./assets/urgentHelpIcon.png";

const LegalServices = () => {
  return (
    <div className="legal-services-container">
      <h2 className="services-title">Quick Access to Legal Services</h2>
      <div className="services-cards">
        <div className="service-card">
          <div className="service-step-number">1</div>
          <div className="service-icon-wrapper">
            <img
              src={CaseEvaluationIcon}
              alt="Case Evaluation"
              className="service-icon"
            />
          </div>
          <h3 className="service-card-title">
            Get your free case evaluation today
          </h3>
          <p className="service-card-description">
            Submit your case details and receive expert insights to understand your legal options
          </p>
          <button className="service-btn">Submit Your Case Details</button>
        </div>
        <div className="service-card">
          <div className="service-step-number">2</div>
          <div className="service-icon-wrapper">
            <img
              src={LawyerAIIcon}
              alt="Discover Lawyer with AI"
              className="service-icon"
            />
          </div>
          <h3 className="service-card-title">
            Let AI find your ideal lawyer
          </h3>
          <p className="service-card-description">
            Our intelligent AI matches you with the perfect legal expert for your specific needs
          </p>
          <button className="service-btn">Start Your Chat Now</button>
        </div>
        <div className="service-card">
          <div className="service-step-number">3</div>
          <div className="service-icon-wrapper">
            <img
              src={UrgentHelpIcon}
              alt="Urgent Legal Assistance"
              className="service-icon"
            />
          </div>
          <h3 className="service-card-title">
            Need urgent help? Connect instantly
          </h3>
          <p className="service-card-description">
            Get immediate legal assistance from qualified attorneys available for urgent consultations
          </p>
          <button className="service-btn">Get Help Now</button>
        </div>
      </div>
    </div>
  );
};

export default LegalServices;
